:host {
  width: 100%;
  height: 100%;
}

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .form-wrapper {
      display: flex;
      flex-direction: column;
      min-width: 500px;
      width: 100%;
      height: 100%;
      overflow-y: auto;

      padding-left: calc(var(--spacer) * 5);
      padding-right: var(--spacer);

      gz-phasr-behavioral-profiles-restrict {
        height: 100%;
      }
    }

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--grey-layout-chart-100);

      padding-left: calc(var(--spacer) * 2);
      padding-right: calc(var(--spacer) * 2);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }
    }

    #description-container {
      width: 1056px;
      justify-content: start;

      #description-text{
        font-size: var(--body-size-large);
        line-height: 21px;
        font-family: "IBMPlexSans", "IBM Plex Sans", sans-serif;
        color: var(--main-titles-inputs-600);
      }
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

gz-collapsable-container {
  margin-bottom: calc(var(--spacer) * 3);
}

gz-collapsable-container::part(button-show-more) {
  justify-content: start;
  margin-left: -10px;
}

gz-labeled-content {
  --label-width-percentage: 15%;
  --value-width-percentage: 85%;
  --font-family: "IBMPlexSans", "IBM Plex Sans", sans-serif;
  margin-top: calc(var(--spacer) * 1);
  height: 25px;
}

gz-text {
  font-family: "IBMPlexSans", "IBM Plex Sans", sans-serif;
  font-weight: 400;
}

gz-text[class='label-percentage'] {
  color: var(--green-layout-100-primary-green);
}
